import { InputText } from "@bluframe/blublocks"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldValue
} from "components/Fields/styled"

import { ComponentProps } from "."

const EditableField = ({
  error,
  errorText,
  fieldRef,
  id,
  infoText,
  isEditMode,
  label,
  onChange,
  name,
  value
}: ComponentProps) =>
  isEditMode ? (
    <InputText
      defaultValue={value}
      error={error}
      errorText={errorText}
      infoText={infoText}
      inputId={id}
      label={label}
      name={name}
      onChange={onChange}
      ref={fieldRef}
    />
  ) : (
    <FieldLabelAndValue>
      <FieldLabel id={id}>{label}</FieldLabel>

      <FieldValue aria-labelledby={id}>{value}</FieldValue>
    </FieldLabelAndValue>
  )

export default EditableField
